import { WalletDrawerTranslations } from ".";

export const WALLET_DRAWER_ES_MX: WalletDrawerTranslations = {
	title: "Tu Cartera Zig",
	totalBalance: "Saldo Total",
	transactions: "Transacciones",
	withdrawal: "Retiro",
	anticipation: "Anticipación",
	ticketPayment: "Pago de Boletos",
	transferBetweenPlaces: "Transferencia entre Lugares",
};
